// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__DkJj4","normalShadow":"Card_normalShadow__t-pPS","softShadow":"Card_softShadow__1DuwH","link":"Card_link__oL6q6","cardBg":"Card_cardBg__3VJiM"};